import { Quill } from 'react-quill'

///
let Block = Quill.import('blots/block')

class Div extends Block {}

Div.tagName = "div"
Div.blotName = "div"
Div.allowedChildren = Block.allowedChildren
Div.allowedChildren.push(Block)

export default Div


// WEBPACK FOOTER //
// ./src/vendor/div-blot.js